<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="cbp-spmenu-push">
    <!-- banner -->
    <div class="banner">
      <div class="container">
        <div class="banner-info">
          <span>品質與安全</span>
        </div>
      </div>
    </div>
    <!-- banner-bottom -->
    <section>
      <!-- 品质管理 -->
      <section id="pzgl">
        <div class="container gradient-background">
          <div class="row">
            <div class="col-lg-12 rzTop">
              <h1><span>華胤集團品質管理系統</span></h1>
              <p class="rzp">
                華胤的品質政策是堅持以不妥協精神,致力於依照客戶要求及技術規範,採取持續改善產品的態度,精益求精,並與我們的客戶所指派監督團隊密切合作,確保符合主管機關所訂之規範標準並以超越客戶之要求為目標。<br /><br />
                華胤品質管理之重點為客戶導向,具備領導層之高度重視並以全員參與做法來取得更好之績效。在執行層面,華胤致力建立合理工作環境,長期推廣5S管理制度,讓內部資源作最有效率之發揮,配合質量檢驗部門人員深入現場糾正指導,務必在第一時間發現問題並予與解決。華胤注重嚴格的制程管理和品質控制，貫穿從原料到成品的每個制造細節。我們和客戶一起努力，使華胤制造的每一支構件都臻於完美。
              </p>
              <div class="container-fluid">
                <div
                  class="col-lg-3 col-xs-6"
                  v-for="(item, index) in pzglList"
                  :key="index"
                >
                  <div class="pzglImg">
                    <img
                      :src="item.image"
                      alt=""
                      style="width: 100%; height: 100%"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 產品質量 -->

          <div class="row" id="cpzl">
            <div class="col-lg-12 cpTop">
              <h1><span>產品質量</span></h1>
            </div>
          </div>
          <div class="container-fluid">
            <carousel-3d
              :controlsVisible="true"
              :width="cWidth"
              :height="cHeight"
              :display="cNum"
              :space="280"
            >
              <slide
                v-lazy-container="{ selector: 'img' }"
                :index="index"
                v-for="(item, index) in cpzlList"
                :key="index"
              >
                <div class="col-lg-12 col-xs-12">
                  <h2 class="slideh2">{{ item.title }}</h2>
                  <div class="col-lg-6">
                    <img :data-src="item.img1" class="slideImg" alt="" />
                    <p class="slideP">{{ item.txt1 }}</p>
                  </div>
                  <div class="col-lg-6">
                    <img :data-src="item.img2" class="slideImg" alt="" />
                    <p class="slideP">{{ item.txt2 }}</p>
                  </div>
                </div>
                <p
                  class="slideP"
                  style="
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%, 0);
                  "
                >
                  第{{ index + 1 }}頁/共23頁
                </p>
              </slide>
            </carousel-3d>
          </div>

          <!-- 產品包裝 -->
          <div class="row" id="cpbz">
            <div class="col-lg-12 rzTop">
              <h1><span>產品包裝</span></h1>
              <p class="rzp">
                為了使客戶收到的每一支構件都和剛出廠時一樣完美，華胤依據運輸的距離、方式以及客戶的要求對產品進行包裝。優良的包裝使得構件在嚴苛的運輸過程中得到保護，這使得我們的產品可以裝運到任何地方。我們的產品曾被運送到美國、日本、歐洲、澳州、韓國、泰國、南非、海地、安哥拉等30多個國家。
              </p>
              <div class="container-fluid">
                <div
                  class="col-lg-4 col-xs-6"
                  v-for="(item, index) in cpbzList"
                  :key="index"
                >
                  <div class="cpbzImg">
                    <img
                      :src="item.image"
                      alt=""
                      style="width: 100%; height: 100%"
                    />
                  </div>
                  <div class="cpp">
                    <p>{{ item.text }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 安全政策 -->
          <div class="row" id="aqzc">
            <div class="col-lg-12 rzTop">
              <h1><span>華胤集團職業安全政策</span></h1>
              <p class="rzp">
                華胤集團以「零工安意外」為目標，嚴格遵循職業安全法規與國際標準，並取得
                AISC、AWS、CWB W47.1/ CSA A660-10、EN 1090、ISO 3834、ISO
                45001、ISO 9001、ISO 14001、中國鋼構一級資質及日本 JSA
                等多項權威認證。我們落實安全政策，要求廠區全員正確配戴
                PPE（個人防護裝備），並推行教育訓練、現場稽核與自動檢查。憑藉嚴謹的安全管理與卓越品質，多次榮獲國際總包商頒發「安全工時獎」與「優秀鋼結構供應商」，成為全球工程信賴的合作夥伴。
              </p>
            </div>
            <div class="col-lg-12" style="text-align: center">
              <img src="@/components/img/pzyaq/aqzc.jpg" alt="" class="aqImg" />
            </div>
          </div>
        </div>
      </section>
      <!-- 邮箱 -->
      <div class="mailbg">
        <to-mail button-text="聯絡我們"></to-mail>
      </div>
      <!-- 小滾輪 -->
      <div id="ss_menu">
        <div>
          <i
            ><a @click="forId('pzgl')">品質<br />管理</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('cpzl')">產品<br />質量</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('cpbz')">產品<br />包裝</a></i
          >
        </div>
        <div>
          <i
            ><a @click="forId('aqzc')">安全<br />政策</a></i
          >
        </div>
        <div class="menu">
          <div class="share" id="ss_toggle" data-rot="180">
            <div class="circle"></div>
            <div class="bar"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pzglList: [
        {
          image: require('@/components/img/pzyaq/pzgl1.jpg'),
        },
        {
          image: require('@/components/img/pzyaq/pzgl2.jpg'),
        },
        {
          image: require('@/components/img/pzyaq/pzgl3.jpg'),
        },
        {
          image: require('@/components/img/pzyaq/pzgl4.jpg'),
        },
      ],
      cpzlList: [
        {
          title: '原材料管理',
          img1: require('@/components/img/pzyaq/cpdb1.jpg'),
          txt1: '常見問題：原材料隨意亂放，不同的材質沒有做區分，工人很容易亂拿，亂用。',
          img2: require('@/components/img/pzyaq/cpdb1-1.jpg'),
          txt2: '華胤：有合適的庫位且材料辦法整齊',
        },
        {
          title: '顔色及條碼管理',
          img1: require('@/components/img/pzyaq/cpdb2.jpg'),
          txt1: '常見問題：材料無標示，制作上容易出錯。',
          img2: require('@/components/img/pzyaq/cpdb2-1.jpg'),
          txt2: '華胤：不同的鋼種用顔色刷塗做區分',
        },
        {
          title: '原材料供應商',
          img1: require('@/components/img/pzyaq/cpdb3.jpg'),
          txt1: '常見問題：選擇沒有任何標識的鋼廠，屬於“三無”産品。',
          img2: require('@/components/img/pzyaq/cpdb3-1.jpg'),
          txt2: '華胤：選擇國內大品牌鋼廠：首鋼，馬鋼等。',
        },
        {
          title: '鋼板切割質量',
          img1: require('@/components/img/pzyaq/cpdb4.jpg'),
          txt1: '常見問題：切割面凹凸不平,有鋸齒缺陷,外觀質量非常差。',
          img2: require('@/components/img/pzyaq/cpdb4-1.jpg'),
          txt2: '華胤：CNC切割，切割表面質量良好。',
        },
        {
          title: '自由邊倒角打磨',
          img1: require('@/components/img/pzyaq/cpdb5.jpg'),
          txt1: '常見問題：自由未做倒角打磨,有毛刺未去除。',
          img2: require('@/components/img/pzyaq/cpdb5-1.jpg'),
          txt2: '華胤：所有切割面及自由邊都倒角打磨。',
        },
        {
          title: '引弧板',
          img1: require('@/components/img/pzyaq/cpdb6.jpg'),
          txt1: '常見問題：沒有裝引弧板。',
          img2: require('@/components/img/pzyaq/cpdb6-1.jpg'),
          txt2: '華胤：BH埋弧焊縫裝引弧板。',
        },
        {
          title: '倒角',
          img1: require('@/components/img/pzyaq/cpdb7.jpg'),
          txt1: '常見問題：螺栓孔有毛刺,影響油漆的附著力',
          img2: require('@/components/img/pzyaq/cpdb7-1.jpg'),
          txt2: '華胤：所有螺栓孔都倒角打磨',
        },
        {
          title: '過焊孔倒角',
          img1: require('@/components/img/pzyaq/cpdb8.jpg'),
          txt1: '常見問題：不開過焊孔， 三條焊縫交叉處成型非常差，有弧坑缺陷',
          img2: require('@/components/img/pzyaq/cpdb8-1.jpg'),
          txt2: '華胤：主要焊縫交叉處有開過焊孔，防止産生應力集中，並且包角焊縫合格。',
        },
        {
          title: '定位焊',
          img1: require('@/components/img/pzyaq/cpdb9.jpg'),
          txt1: '常見問題：沒有工藝要求， 隨意進行點焊.',
          img2: require('@/components/img/pzyaq/cpdb9-1.jpg'),
          txt2: '華胤：有工藝要求進行點焊固定，長度要求100~150，間距300~400。',
        },
        {
          title: '埋弧焊',
          img1: require('@/components/img/pzyaq/cpdb10.jpg'),
          txt1: '常見問題：焊角大小不均勻，焊道與母材之間未圓滑過渡、有效熔合',
          img2: require('@/components/img/pzyaq/cpdb10-1.jpg'),
          txt2: '華胤：焊縫圓滑過渡，外觀非常美觀，沒有任何焊縫缺陷。',
        },
        {
          title: '焊縫內部剖視',
          img1: require('@/components/img/pzyaq/cpdb11.jpg'),
          txt1: '常見問題：焊縫內部剖示後,沒有熔合。',
          img2: require('@/components/img/pzyaq/cpdb11-1.jpg'),
          txt2: '華胤：焊縫內部剖示後，完全熔合',
        },
        {
          title: '鋼構矯正',
          img1: require('@/components/img/pzyaq/cpdb12.jpg'),
          txt1: '常見問題：焊接後扭麯變形，不做矯正處理。',
          img2: require('@/components/img/pzyaq/cpdb12-1.jpg'),
          txt2: '華胤：矯正後符合規範要求。',
        },
        {
          title: '切割',
          img1: require('@/components/img/pzyaq/cpdb13.jpg'),
          txt1: '常見問題：手工切割不平直，割紋深，有渣未清除。',
          img2: require('@/components/img/pzyaq/cpdb13-1.jpg'),
          txt2: '華胤：機器切割平直光滑，無缺陷。',
        },
        {
          title: '平臺梁制作',
          img1: require('@/components/img/pzyaq/cpdb14.jpg'),
          txt1: '常見問題：採用手工切割，沒有R角。',
          img2: require('@/components/img/pzyaq/cpdb14-1.jpg'),
          txt2: '華胤：外露R角圓滑過渡。',
        },
        {
          title: '埋弧自動焊（SAW）',
          img1: require('@/components/img/pzyaq/cpdb15.jpg'),
          txt1: '常見問題：國內埋弧焊機焊出來質量很差。',
          img2: require('@/components/img/pzyaq/cpdb15-1.jpg'),
          txt2: '華胤：進口埋弧焊機很先進，焊出來構建質量很好',
        },
        {
          title: '破口面切割',
          img1: require('@/components/img/pzyaq/cpdb16.jpg'),
          txt1: '常見問題：切割面不平直，有缺口。',
          img2: require('@/components/img/pzyaq/cpdb16-1.jpg'),
          txt2: '華胤：切割面平整，光滑。',
        },
        {
          title: '拚裝工藝',
          img1: require('@/components/img/pzyaq/cpdb17.jpg'),
          txt1: '常見問題：沒有拚裝工藝要求。',
          img2: require('@/components/img/pzyaq/cpdb17-1.jpg'),
          txt2: '華胤：按制作工藝開坡口，打磨拚裝',
        },
        {
          title: 'SMAW焊縫',
          img1: require('@/components/img/pzyaq/cpdb18.jpg'),
          txt1: '常見問題：焊縫粗糙，成型很差。',
          img2: require('@/components/img/pzyaq/cpdb18-1.jpg'),
          txt2: '華胤：焊縫圓滑、整齊。',
        },
        {
          title: '多道焊',
          img1: require('@/components/img/pzyaq/cpdb19.jpg'),
          txt1: '常見問題：焊道與焊道之間未融合。',
          img2: require('@/components/img/pzyaq/cpdb19-1.jpg'),
          txt2: '華胤：焊道與焊道之間光滑整齊。',
        },
        {
          title: 'GMAW焊接',
          img1: require('@/components/img/pzyaq/cpdb20.jpg'),
          txt1: '常見問題：焊縫成型粗糙，外觀有缺陷。',
          img2: require('@/components/img/pzyaq/cpdb20-1.jpg'),
          txt2: '華胤：焊縫成型美觀圓滑過渡。',
        },
        {
          title: '拋丸除鏽',
          img1: require('@/components/img/pzyaq/cpdb21.jpg'),
          txt1: '常見問題：除鏽等級不徹底。',
          img2: require('@/components/img/pzyaq/cpdb21-1.jpg'),
          txt2: '華胤：除鏽等級達到Sa2 ½。',
        },
        {
          title: '噴漆質量',
          img1: require('@/components/img/pzyaq/cpdb22.jpg'),
          txt1: '常見問題：油漆多處碰傷,油漆厚度不均勻。',
          img2: require('@/components/img/pzyaq/cpdb22-1.jpg'),
          txt2: '	華胤：油漆塗層均勻,外觀無缺陷。',
        },
        {
          title: '摩擦面貼紙保護',
          img1: require('@/components/img/pzyaq/cpdb23.jpg'),
          txt1: '常見問題：摩擦面不貼紙,塗漆。',
          img2: require('@/components/img/pzyaq/cpdb23-1.jpg'),
          txt2: '華胤：摩擦面按規範貼紙。',
        },
      ],
      cpbzList: [
        {
          image: require('@/components/img/pzyaq/cpbz1.jpg'),
          text: '貨輪運輸',
        },
        {
          image: require('@/components/img/pzyaq/cpbz2.jpg'),
          text: '大件打包',
        },
        {
          image: require('@/components/img/pzyaq/cpbz3.jpg'),
          text: '集裝箱打包',
        },
        {
          image: require('@/components/img/pzyaq/cpbz4.jpg'),
          text: '小件打包',
        },
        {
          image: require('@/components/img/pzyaq/cpbz5.jpg'),
          text: '模塊打包',
        },
        {
          image: require('@/components/img/pzyaq/cpbz6.jpg'),
          text: '特殊打包',
        },
      ],
    }
  },
  methods: {
    // 調用全局方法，滾動指定id
    forId(tId) {
      console.log(tId)
      this.$store.dispatch('toID', tId)
    },
    changeHeight() {
      if (document.body.clientWidth >= 2000) {
        this.cWidth = 1300
        this.cHeight = 700
        this.cNum = 5
      } else if (
        document.body.clientWidth > 1400 &&
        document.body.clientWidth < 2000
      ) {
        this.cWidth = 1000
        this.cHeight = 650
        this.cNum = 3
      } else if (
        document.body.clientWidth >= 768 &&
        document.body.clientWidth <= 1400
      ) {
        this.cWidth = 600
        this.cHeight = 500
        this.cNum = 3
      } else if (document.body.clientWidth < 768) {
        this.cWidth = 1000
        this.cHeight = 1450
        this.cNum = 3
      }
    },
  },
  mounted() {
    // 獲取高度
    window.onresize = () => {
      this.changeHeight()
    }
  },
  created() {
    this.changeHeight()
  },
  updated() {
    if (this.scrollToElement) {
      this.scrollToElement()
      this.scrollToElement = null
    }
  },
}
</script>

<style scoped>
/* 榮譽圖片註釋設置 */
.cbp-spmenu-push {
  overflow-x: hidden;
  position: relative;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
}
.cbp-spmenu-push .banner {
  background: url(@/components/img/pzyaq/1.jpg) 0px 0px no-repeat;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
  height: 500px;
  position: relative;
  width: 100%;
  background-size: 100% 100%;
}

/*-- banner-info --*/
.banner-info {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.banner-info span {
  font-size: 50px;
  color: #fff;
  padding: 0 10px;
  margin: 0 auto;
  line-height: normal;
  background: rgba(0, 0, 0, 0.6);
  font-weight: 700;
}
/***** Lexi *****/
/* 小滾輪 */
@-webkit-keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
  }
}

@-moz-keyframes badbounce {
  0%,
  100% {
    -moz-transform: translateY(0px);
  }
  10% {
    -moz-transform: translateY(6px);
  }
  30% {
    -moz-transform: translateY(-4px);
  }
  70% {
    -moz-transform: translateY(3px);
  }
  90% {
    -moz-transform: translateY(-2px);
  }
}

@keyframes badbounce {
  0%,
  100% {
    -webkit-transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
    -o-transform: translateY(0px);
    transform: translateY(0px);
  }
  10% {
    -webkit-transform: translateY(6px);
    -moz-transform: translateY(6px);
    -ms-transform: translateY(6px);
    -o-transform: translateY(6px);
    transform: translateY(6px);
  }
  30% {
    -webkit-transform: translateY(-4px);
    -moz-transform: translateY(-4px);
    -ms-transform: translateY(-4px);
    -o-transform: translateY(-4px);
    transform: translateY(-4px);
  }
  70% {
    -webkit-transform: translateY(3px);
    -moz-transform: translateY(3px);
    -ms-transform: translateY(3px);
    -o-transform: translateY(3px);
    transform: translateY(3px);
  }
  90% {
    -webkit-transform: translateY(-2px);
    -moz-transform: translateY(-2px);
    -ms-transform: translateY(-2px);
    -o-transform: translateY(-2px);
    transform: translateY(-2px);
  }
}

.ss_animate {
  -webkit-animation: badbounce 1s linear;
  -moz-animation: badbounce 1s linear;
  animation: badbounce 1s linear;
}

#ss_menu {
  z-index: 999;
  bottom: 10px;
  width: 60px;
  height: 60px;
  color: #fff;
  position: fixed;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  right: 15px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
}

#ss_menu > .menu {
  padding: 32px 0 !important;
  position: absolute;
  border-radius: 50%;
  width: 60px;
  height: 60px !important;
  text-align: center;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.23), 0 3px 10px rgba(0, 0, 0, 0.16);
  color: #fff;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
}

#ss_menu > .menu .share .circle {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  top: 50%;
  margin-top: -6px;
  left: 12px;
  opacity: 1;
}

#ss_menu > .menu .share .circle:after,
#ss_menu > .menu .share .circle:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  opacity: 1;
  display: block;
  position: absolute;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
}

#ss_menu > .menu .share .circle:after {
  left: 20.78461px;
  top: 12px;
}

#ss_menu > .menu .share .circle:before {
  left: 20.78461px;
  top: -12px;
}

#ss_menu > .menu .share .bar {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  top: 50%;
  margin-top: -1.5px;
  left: 18px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(30deg);
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -o-transform: rotate(30deg);
  transform: rotate(30deg);
}

#ss_menu > .menu .share .bar:before {
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  transition: all 1s ease;
  content: '';
  width: 24px;
  height: 3px;
  background: #fff;
  position: absolute;
  left: 0px;
  -webkit-transform-origin: 0% 50%;
  -moz-transform-origin: 0% 50%;
  -ms-transform-origin: 0% 50%;
  -o-transform-origin: 0% 50%;
  transform-origin: 0% 50%;
  -webkit-transform: rotate(-60deg);
  -moz-transform: rotate(-60deg);
  -ms-transform: rotate(-60deg);
  -o-transform: rotate(-60deg);
  transform: rotate(-60deg);
}

#ss_menu > .menu .share.close .circle {
  opacity: 0;
}

#ss_menu > .menu .share.close .bar {
  top: 50%;
  margin-top: -1.5px;
  left: 50%;
  margin-left: -12px;
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(405deg);
  -moz-transform: rotate(405deg);
  -ms-transform: rotate(405deg);
  -o-transform: rotate(405deg);
  transform: rotate(405deg);
}

#ss_menu > .menu .share.close .bar:before {
  -webkit-transform-origin: 50% 50%;
  -moz-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  -o-transform-origin: 50% 50%;
  transform-origin: 50% 50%;
  -webkit-transform: rotate(-450deg);
  -moz-transform: rotate(-450deg);
  -ms-transform: rotate(-450deg);
  -o-transform: rotate(-450deg);
  transform: rotate(-450deg);
}

#ss_menu > .menu.ss_active {
  background: #415160;
  -webkit-transform: scale(0.7);
  -moz-transform: scale(0.7);
  -ms-transform: scale(0.7);
  -o-transform: scale(0.7);
  transform: scale(0.7);
}

#ss_menu > div {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  position: absolute;
  width: 60px;
  height: 60px;
  font-size: 13px;
  text-align: center;
  background: #415160;
  border-radius: 50%;
  display: table;
}

#ss_menu > div i {
  display: table-cell;
  vertical-align: middle;
}
#ss_menu > div a {
  color: #ffffff;
  text-decoration: none;
}
#ss_menu > div:hover {
  background: #2a2f34;
  cursor: pointer;
}

#ss_menu div:nth-child(1) {
  top: 0px;
  left: -160px;
}

#ss_menu div:nth-child(2) {
  top: -80px;
  left: -138.56406px;
}

#ss_menu div:nth-child(3) {
  top: -138.56406px;
  left: -80px;
}

#ss_menu div:nth-child(4) {
  top: -160px;
  left: 0px;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}

.hspan,
.hspan2 {
  display: inline-block;
  position: relative;
  padding: 10px 20px;
  font-size: 30px;
  font-weight: 600;
}

.hspan::after,
.hspan2::after {
  content: '';
  position: absolute;
  bottom: 0;
  width: 150%;
  height: 3px;
  background-color: #8e8e8b;
  transition: width 0.3s ease;
}
.hspan::after {
  left: 13%;
}
.hspan2::after {
  left: 8%;
}
.pzglImg {
  position: relative; /* 父容器设为相对定位 */
  width: 100%;
  height: 30vw; /* 按需设置高度 */
  overflow: hidden; /* 防止图片溢出 */
  margin: 15px 0;
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

.cpbzImg {
  position: relative; /* 父容器设为相对定位 */
  width: 100%;
  height: 18vw; /* 按需设置高度 */
  overflow: hidden; /* 防止图片溢出 */
  margin: 0;
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

.cpp {
  margin: 20px 0;
  text-align: center;
  font-size: 25px;
}

.container-fluid {
  margin: 70px auto;
}

.rzTop {
  margin: 90px 0;
  text-align: center;
}
.aqTop {
  margin: 0 0 90px 0;
  text-align: center;
}
.rzTop h1,
.aqTop h1 {
  margin: 50px 0;
}
.rzTop h1 span,
.aqTop h1 span {
  padding-bottom: 0;
  font-size: 37px;
  font-weight: 800;
}
.rzTop .rzp,
.aqTop .aqp {
  margin: 0 auto;
  width: 85vw;
  text-align: left;
  font-size: 26px;
  line-height: 40px;
}
.zzzsHeight {
  height: 70px;
}
.sjzxHeight {
  height: 70px;
}
.jtzlHeight {
  height: 70px;
}
.hover-content h1 {
  font-size: 22px;
  font-weight: 600;
  margin-top: 20px;
  margin-bottom: 10px;
}
.gradient-background {
  padding: 0 85px 100px;
  border-top: 1px solid #000;
  width: 100%;
  height: 100%; /* 設置高度為視口高度 */
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.mailbg {
  background: linear-gradient(
    to right,
    #ccc 0%,
    /* 左邊灰色 */ #ccc 5%,
    /* 灰色延伸到 25% */ #fff 20%,
    #fff 80%,
    /* 中間白色 */ #ccc 95%,
    /* 灰色延伸到 75% */ #ccc 100% /* 右邊灰色 */
  );
}

.cpTop {
  margin: 90px 0 0 0;
  text-align: center;
}
.cpTop h1 {
  margin: 50px 0 0 0;
}
.cpTop h1 span {
  padding-bottom: 0px;
  font-size: 37px;
  font-weight: 800;
}

.jtzlImg {
  border: 1px solid #000;
  text-align: center;
  background-color: #fff;
}

div /deep/ .jtzlImg img {
  padding: 5px;
  width: 100%;
  overflow: hidden;
  height: 10vw;
  border: 0;
}
/* 榮譽圖片註釋設置 */
.slideImg {
  width: 100%;
  height: 450px;
  margin-bottom: -30px;
  padding-bottom: 30px;
}
.slideh2 {
  text-align: center;
  font-size: 30px;
  margin-top: 20px;
  margin-bottom: 15px;
}
.slideP {
  padding-top: 10px;
  font-size: 20px;
  line-height: 30px;
}
#cpzl,
#cpbz,
#aqzc {
  border-top: 1px solid #000;
}

.aqImg {
  width: 80vw;
}

.carousel-3d-slide {
  background-color: #fff;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
}
@media screen and (max-width: 1400px) {
  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan {
    font-size: 22px;
  }
  .slideImg {
    height: 170px;
  }
  .slideP {
    padding-top: 5px;
    font-size: 18px;
    line-height: 24px;
  }

  .xnytitle {
    font-size: 32px;
  }
  .rzTop h1 span,
  .cpTop h1 span {
    font-size: 25px;
  }
  .gradient-background {
    padding: 0 0 30px 0;
    background: white;
  }
  .mailbg {
    background: white;
  }

  .rzTop {
    margin: 15px 0;
  }
  .cpTop {
    margin: 0;
  }
  .rzTop h1,
  .cpTop h1 {
    margin: 30px 0;
  }
  .rzTop .rzp {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 19px;
    font-weight: 500;
    line-height: 20px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 10px;
  }

  .cpbzImg {
    height: 28vw;
  }
  .cpp {
    font-size: 18px;
    margin: 10px 0;
  }
  .container-fluid {
    margin: 15px 0;
  }
  .slideh2 {
    font-size: 24px;
  }
  .pzglImg {
    height: 45vw;
    margin: 10px 0;
  }
  .banner-info span {
    font-size: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 350px;
  }
  .aqImg {
    width: 90vw;
  }
}

@media screen and (max-width: 768px) {
  .onlyPC {
    display: inline;
  }
  .container {
    padding: 0;
  }
  .button {
    margin: 10px 0;
    padding: 2px;
    font-size: 2em;
  }
  .hspan {
    font-size: 22px;
  }
  .slideImg {
    height: 170px;
  }
  .slideP {
    padding-top: 5px;
    font-size: 13px;
    line-height: 20px;
  }

  .xnytitle {
    font-size: 32px;
  }
  .rzTop h1 span,
  .cpTop h1 span {
    font-size: 20px;
  }
  .gradient-background {
    padding: 0 0 30px 0;
    background: white;
  }
  .mailbg {
    background: white;
  }

  .rzTop {
    margin: 15px 0;
  }
  .cpTop {
    margin: 0;
  }
  .rzTop h1,
  .cpTop h1 {
    margin: 30px 0;
  }
  .rzTop .rzp {
    margin: 0 auto;
    width: 85vw;
    text-align: left;
    font-size: 13px;
    font-weight: 500;
    line-height: 20px;
  }
  .col-xs-6,
  .col-xs-4 {
    padding: 0 5px;
  }

  .cpbzImg {
    height: 28vw;
  }
  .cpp {
    font-size: 13px;
    margin: 10px 0;
  }
  .container-fluid {
    margin: 10px 0;
  }
  .slideh2 {
    font-size: 20px;
  }
  .pzglImg {
    height: 50vw;
    margin: 5px 0;
  }
  .banner-info span {
    font-size: 30px;
  }
  .cbp-spmenu-push .banner {
    height: 200px;
  }
  .aqImg {
    width: 90vw;
  }
}
@media screen and (min-width: 2000px) {
  .banner-info span {
    font-size: 65px;
  }
  .rzTop h1 span,
  .cpTop h1 span {
    font-size: 40px;
  }
  .rzTop .rzp {
    font-size: 29px;
    line-height: 1.5;
  }
  .slideh2 {
    font-size: 35px;
    margin: 50px 0 30px 0;
  }
  .slideP {
    font-size: 26px;
    line-height: 1.5;
  }
  .cpp {
    font-size: 26px;
  }
}
</style>
